import { useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { UseI18n } from '../../../../common/hooks/useI18n'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { getUnique, removeAccents } from '../../../../helpers/common'
import { MAX_ADDITIONAL_INFO } from '../../common/constant'
import { CustomDropdown } from '../../common/customDropdown'
import { Input } from '../../common/input'
import {
  changeAlertPopup,
  selectFinancials,
  selectScreeningIndicatorById,
  selectYearReports,
} from '../../common/store/slice'
import { changeViews, selectViews, selectViewsCount } from '../store/slice'
import classes from './index.module.scss'

export const SearchFinancial = () => {
  const dispatch = useDispatch()

  const screeningIndicatorById = useSelector(selectScreeningIndicatorById())
  const financials = useSelector(selectFinancials)
  const yearReports = useSelector(selectYearReports)
  const viewsData = useSelector(selectViews)
  const viewsCount = useSelector(selectViewsCount)

  const selectedIndicatorIds = viewsData.map(
    (item) => item.screeningIndicatorId,
  )
  const placeholderText = UseI18n('screening.SEARCH_INFORMATION')

  const [keyword, setKeyword] = useState('')

  const data = useMemo(() => {
    return Object.values(financials).reduce(
      (prev, curr) => [
        ...prev,
        ...Object.values(curr).reduce((a, b) => [...a, ...b], []),
      ],
      [],
    )
  }, [financials])

  const searchData = useMemo(() => {
    const result = data.filter((item) => {
      const formatItemName = removeAccents(
        item.screeningIndicatorName.toLowerCase(),
      )
      const formatKeyword = removeAccents(keyword.trim().toLowerCase())
      return formatItemName.includes(formatKeyword)
    })

    return result.filter((item, index) => {
      return (
        result.findIndex(
          (x) => x.screeningIndicatorName === item.screeningIndicatorName,
        ) === index
      )
    })
  }, [data, selectedIndicatorIds, keyword])

  const onToggleShowDropdown = (isShow) => {
    if (!isShow) {
      setKeyword('')
    }
  }

  const renderElement = () => {
    return (
      <Input
        noControl
        value={keyword}
        onChange={(e) => setKeyword(e.target.value)}
        placeholder={placeholderText}
        inputStyle={{ fontSize: 14 }}
        wrapperStyle={{ padding: '5px 12px', backgroundColor: '#FFFFFF' }}
        prefix={
          <Icon className="icon-search pr1" style={{ color: '#9C9C9C' }} />
        }
      />
    )
  }

  const checkMaxAdditionalInfo = () => {
    if (viewsCount >= MAX_ADDITIONAL_INFO) {
      dispatch(
        changeAlertPopup({
          isShow: true,
          title: 'screening.WARNING',
          message: 'screening.MAX_ADDITIONAL_INFO_MESS',
          translateProps: { max: MAX_ADDITIONAL_INFO },
        }),
      )
      return true
    }
  }

  const handleChoose = (item) => {
    if (checkMaxAdditionalInfo()) return

    const screeningIndicatorIdsUpdate = Object.values(screeningIndicatorById)
      .filter(
        (indicator) =>
          indicator.fsTypeCode === item.fsTypeCode &&
          indicator.screeningIndicatorName === item.screeningIndicatorName,
      )
      .map((i) => i.screeningIndicatorId)

    const groupId = getUnique()
    dispatch(
      changeViews([
        ...viewsData,
        ...screeningIndicatorIdsUpdate.map((id) => ({
          screeningIndicatorId: id,
          year: yearReports[0],
          groupId,
        })),
      ]),
    )
  }

  const renderDropdown = ({ hideDropdown }) => {
    if (!searchData.length) {
      return (
        <Element className="wh100 dFlex justifyContentCenter alignItemsCenter">
          <Translate value="screening.NO_DATA_SEARCH" />
        </Element>
      )
    }

    return searchData.map((item, index) => (
      <DropdownItem
        key={index}
        item={item}
        hideDropdown={hideDropdown}
        handleChoose={handleChoose}
      />
    ))
  }

  return (
    <Element className={classes.inputSearch}>
      <CustomDropdown
        renderElement={renderElement}
        renderDropdown={renderDropdown}
        onToggleShowDropdown={onToggleShowDropdown}
        dropdownItemHeight={22}
        dropdownStyle={{ padding: 0 }}
      />
    </Element>
  )
}

const DropdownItem = ({ item, hideDropdown, handleChoose }) => {
  const [bgColor, setBgColor] = useState('transparent')

  const onMouseEnter = () => {
    setBgColor('#EDF5FE')
  }

  const onMouseLeave = () => {
    setBgColor('transparent')
  }

  return (
    <Element
      onClick={() => {
        hideDropdown()
        handleChoose(item)
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={classes.selectSearchItem}
      style={{ backgroundColor: bgColor }}
    >
      <Element className="fw600" style={{ color: '#3A414B' }}>
        {item.screeningIndicatorName}
      </Element>
    </Element>
  )
}
